







































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Dashboard from '@/modules/dashboard/classes/dashboard';
import notificationService from '@/services/notificationService';

import cCard from '@/components/default/Card.vue';
import cPopup from '@/components/default/Popup.vue';
import { DxList } from 'devextreme-vue';

import space from '../components/space.vue';
import graph from '../components/graph.vue';
import pointOfInterest from '../components/pointOfInterest.vue';

@Component({
  components: {
    cCard,
    cPopup,
    DxList,
    space,
    graph,
    pointOfInterest,
  },
})
export default class DashboardDetailPage extends Vue {
  private dashboard: Dashboard = new Dashboard();
  private initialised: boolean = false;
  private showElements: boolean = false;
  private reload: boolean = false;

  private mounted() {
    this.loadData();
  }

  private async loadData() {
    try {
      this.dashboard = new Dashboard(this.$route.params.id);
    } catch (err) {
      notificationService.failedToLoad();
    } finally {
      this.initialised = true;
    }
  }

  private reorderList(e: any) {
    if (e.toIndex >= this.dashboard.items.length) {
        let k = e.toIndex - this.dashboard.items.length + 1;
        while (k--) {
            this.dashboard.items.push({itemType: ''});
        }
    }
    this.dashboard.items.splice(e.toIndex, 0, this.dashboard.items.splice(e.fromIndex, 1)[0]);
  }

  private updateItem(index: number, e: any) {
    this.reload = true;
    this.dashboard.items[index] = e;
    this.dashboard.saveChanges();
    setTimeout(() => {
      this.reload = false;
    }, 200);
  }

  private save() {
    this.dashboard.saveChanges();
  }

  private setWidth(item: IDashboardItem) {
    if (item.itemType === 'space') {
      return 'col-12';
    } else {
      if ((item as IDashboardDisplayItem).width) {
        return 'col-' + (item as IDashboardDisplayItem).width;
      }
      return 'col-12';
    }
  }

  private async deleteItem(index: number) {
    if (confirm('Bent u zeker?')) {
      this.dashboard.items.splice(index, 1);
    }
  }

  get id() {
    return this.$route.params.id;
  }
}
